export default {"src":"/login-app/[GIT_HASH]/_next/static/media/role_editor.a13eac80.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};